import {JobEventTypeEnum} from "./JobEvent";

export enum JobEventCategory {
	Contact = "Contact",
	Status = "Status",
	Notes = "Notes",
	Reminders = "Reminders",
	Appointments = "Appointments",
	Files = "Files",
	Updates = "Job Updates",
	Quotes = "Quotes",
	Surveys = "Surveys"
}

/**
 * Job event type object model.
 */
export default class JobEventTypeObject {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to JobEventTypeObject.
	 * @param {string} string
	 * @return {JobEventTypeObject}
	 */
	public static fromString(string: string): JobEventTypeObject {
		return new JobEventTypeObject(string)
	}

	/**
	 * Get JobEventTypeObjects for given category.
	 * @param {string} filter Category key.
	 * @return {JobEventTypeObject[]} List of JobEventTypeObjects for given category.
	 */
	public static getTypesForCategory(filter: string): JobEventTypeObject[] {
		if (filter === JobEventCategory.Contact) {
			return JobEventTypeObject.getContactTypes();
		}
		if (filter === JobEventCategory.Status) {
			return JobEventTypeObject.getStatusTypes();
		}
		if (filter === JobEventCategory.Appointments) {
			return JobEventTypeObject.getAppointmentsTypes();
		}
		if (filter === JobEventCategory.Files) {
			return JobEventTypeObject.getFilesTypes();
		}
		if (filter === JobEventCategory.Updates) {
			return JobEventTypeObject.getUpdatesTypes();
		}
		if (filter === JobEventCategory.Quotes) {
			return JobEventTypeObject.getQuotesTypes();
		}
		if (filter === JobEventCategory.Surveys) {
			return JobEventTypeObject.getSurveysTypes();
		}

		if (filter === JobEventCategory.Notes) {
			return JobEventTypeObject.getNotesTypes();
		}
		if (filter === JobEventCategory.Reminders) {
			return JobEventTypeObject.getRemindersTypes();
		}
		return null;
	}

	public static getContactTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.JobSmsSent),
			JobEventTypeObject.fromString(JobEventTypeEnum.JobEmailSent),
			JobEventTypeObject.fromString(JobEventTypeEnum.ExternalCallRegistered)
		];
	}

	public static getStatusTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.StatusChanged),
		];
	}

	public static getNotesTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.Note),
		];
	}

	public static getRemindersTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.NoteReminder),
		];
	}

	public static getAppointmentsTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.AppointmentCreated),
			JobEventTypeObject.fromString(JobEventTypeEnum.AppointmentUpdated),
			JobEventTypeObject.fromString(JobEventTypeEnum.AppointmentStatusChanged),
		];
	}

	public static getFilesTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.JobFilesAttached),
			JobEventTypeObject.fromString(JobEventTypeEnum.JobFilesDeleted),
		];
	}

	public static getUpdatesTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.Created),
			JobEventTypeObject.fromString(JobEventTypeEnum.Updated),
			JobEventTypeObject.fromString(JobEventTypeEnum.CreatedFromQuote),
			JobEventTypeObject.fromString(JobEventTypeEnum.BdpAssigneeChanged),
			JobEventTypeObject.fromString(JobEventTypeEnum.AgentAssigneeChanged),
			JobEventTypeObject.fromString(JobEventTypeEnum.WatchersChanged),
			JobEventTypeObject.fromString(JobEventTypeEnum.InvoicePathChanged),
			JobEventTypeObject.fromString(JobEventTypeEnum.MarkedAsPaid),
			JobEventTypeObject.fromString(JobEventTypeEnum.UnMarkedAsPaid)
		];
	}

	public static getQuotesTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.QuoteAccepted),
		];
	}

	public static getSurveysTypes(): JobEventTypeObject[] {
		return [
			JobEventTypeObject.fromString(JobEventTypeEnum.SurveyCreated),
			JobEventTypeObject.fromString(JobEventTypeEnum.SurveyFilesAttached),
		]
	}
}
